import Home from '@/pages/Home'
import About from '@/pages/About'
import Sostenibilita from '@/pages/Sostenibilita'
import Certificazioni from '@/pages/Certificazioni'
import Story from '@/pages/Story'
import Research from '@/pages/Research'
import Group from '@/pages/Group'
import ArchiveCategories from '@/pages/ArchiveCategories'
import ArchiveProducts from '@/pages/ArchiveProducts'
import Product from '@/pages/Product'
import ArchiveCaseStudies from '@/pages/ArchiveCaseStudies'
import CaseStudy from '@/pages/CaseStudy'
import ArchiveNews from '@/pages/ArchiveNews'
import News from '@/pages/News'
import Art from '@/pages/Art'
import Contact from '@/pages/Contact'
import NotFound from '@/pages/NotFound'

export default (routing, lang) => [
  {
    key: 0,
    path: `/${lang}`,
    exact: true,
    component: () => <Home stub={routing.find((r) => r.cpt === 'homepage')?.slug} />,
  },
  {
    key: 1,
    path: routing.map((route) => {
      if (route.cpt === 'story') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => <Story stub={routing.find((r) => r.cpt === 'story')?.slug} />,
  },
  {
    key: 2,
    path: routing.map((route) => {
      if (route.cpt === 'research') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => <Research stub={routing.find((r) => r.cpt === 'research')?.slug} />,
  },
  {
    key: 3,
    path: routing.map((route) => {
      if (route.cpt === 'group') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => <Group stub={routing.find((r) => r.cpt === 'group')?.slug} />,
  },
  {
    key: 4,
    path: routing.map((route) => {
      if (route.cpt === 'archive_categories') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => (
      <ArchiveCategories
        stub={routing.find((r) => r.cpt === 'archive_categories')?.slug}
        cpt="_cta_category_product"
      />
    ),
  },
  {
    key: 5,
    path: routing.map((route) => {
      if (route.cpt === '_cta_category_product') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => (
      <ArchiveProducts
        stub={routing.find((r) => r.cpt === '_cta_category_product')?.slug}
        cpt="_cta_category_product"
      />
    ),
  },
  {
    key: 6,
    path: `/${lang}${routing.find((r) => r.cpt === 'product')?.slug}`,
    component: () => <Product cpt="product" />,
  },
  {
    key: 7,
    path: routing.map((route) => {
      if (route.cpt === 'archive_case_studies') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => (
      <ArchiveCaseStudies
        stub={routing.find((r) => r.cpt === 'archive_case_studies')?.slug}
        cpt="case-studies"
      />
    ),
  },
  {
    key: 8,
    path: routing.filter((r) => r.cpt === 'case_studies').map((item) => `/${lang}${item.slug}`),
    component: () => <CaseStudy cpt="case-studies" />,
  },
  {
    key: 9,
    path: routing.filter((r) => r.cpt === 'post').map((item) => `/${lang}${item.slug}`),
    component: () => <News cpt="posts" />,
  },
  {
    key: 10,
    path: routing.map((route) => {
      if (route.cpt === 'archive_news') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => <ArchiveNews cpt="post" stub={routing.find((r) => r.cpt === 'archive_news')?.slug} />,
  },
  {
    key: 11,
    path: routing.map((route) => {
      if (route.cpt === 'art') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => <Art cpt="posts" stub={routing.find((r) => r.cpt === 'art')?.slug} />,
  },
  {
    key: 12,
    path: routing.map((route) => {
      if (route.cpt === 'contact') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => <Contact stub={routing.find((r) => r.cpt === 'contact')?.slug} />,
  },
  ...(routing.filter((r) => r.cpt === 'about').map((route, i) => ({
    key: 13 + i,
    path: `/${lang}${route.slug}`,
    exact: true,
    component: () => <About stub={route.slug} />,
  }))),
  ...(routing.filter((r) => r.cpt === 'editorial').map((route, i) => ({
    key: 13 + i,
    path: `/${lang}${route.slug}`,
    exact: true,
    component: () => <About stub={route.slug} isEditorial />,
  }))),
  ...(routing.filter((r) => r.cpt === 'sostenibilita').map((route, i) => ({
    key: 14 + i,
    path: `/${lang}${route.slug}`,
    exact: true,
    component: () => <Sostenibilita stub={route.slug} />,
  }))),
  ...(routing.filter((r) => r.cpt === 'certificazioni').map((route, i) => ({
    key: 15 + i,
    path: `/${lang}${route.slug}`,
    exact: true,
    component: () => <Certificazioni stub={route.slug} />,
  }))),
  {
    key: 999,
    component: NotFound,
  },
]
